import { gql } from "@apollo/client";

export const GET_COMMENTS = gql`
  query comments($parentId: ID!, $parentType: ParentType) {
    comments(parentId: $parentId, parentType: $parentType) {
      id
      comment
      commentDate
      user {
        id
        firstName
        lastName
        profilePicUrl
      }
      mentions {
        id
        firstName
        lastName
      }
    }
  }
`;

export const ADD_COMMENT = gql`
  mutation addComment(
    $parentId: ID!
    $parentType: ParentType!
    $comment: String!
  ) {
    addComment(
      parentId: $parentId
      parentType: $parentType
      comment: $comment
    ) {
      id
      comment
      commentDate
      user {
        id
        firstName
        lastName
        profilePicUrl
      }
    }
  }
`;

export const DELETE_COMMENT = gql`
  mutation deleteComment($commentId: ID!) {
    deleteComment(commentId: $commentId) {
      response
    }
  }
`;
